<template>
  <modal
    name="versionRevert"
    transition="nice-modal-fade"
    @before-open="beforeOpen"
    :width="540"
    :height="264"
    :pivotY="0.3"
  >
    <div class="container">
      <div class="content">
        <div>
          确定要还原到选中版本吗？还原之后将会覆盖你当前的项目数据。
        </div>
        <div class="checkbox-row">
          <i
            class="checkbox__icon"
            :class="[checked ? `icon-checkbox-checked` : `icon-checkbox-empty`]"
            @click="toggleChecked"
          ></i>
          <span>保存当前项目为新版本，方便之后回溯及还原</span>
        </div>
      </div>
      <div class="footer">
        <div
          class="button button--default"
          @click="cancel"
        >取消</div>
        <div
          class="button button--primary"
          @click="confirm"
        >确定</div>
      </div>
      <div
        class="close-btn"
        @click="clickToClose()"
      >
        <i class="icon-popup-close"></i>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  data () {
    return {
      checked: true
    };
  },
  created () {

  },
  methods: {
    clickToClose () {
      this.$modal.hide('versionRevert');
      this.$bus.emit('versionRevert.close');
    },
    beforeOpen ({ params } = {}) {
    },
    confirm () {
      this.$bus.emit('versionRevert.confirm', {
        checked: this.checked
      });
    },
    cancel () {
      this.clickToClose();
    },
    toggleChecked () {
      this.checked = !this.checked;
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  // width: 540px;
  // height: 264px;
  width: 420px;
  // height: 210px;
  margin: auto;
  // padding: 50px 88px;
  padding: 50px 20px 30px;
  background-color: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
  border-radius: 4px;
  text-align: center;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  margin-bottom: 36px;
  margin-left: 24px;
  margin-right: 24px;
  line-height: 1.8;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;

  > div:nth-of-type(1) {
    margin-right: 25px;
  }
}

.checkbox-row {
  display: flex;
  align-items: center;
  margin-top: 8px;
  & > i {
    margin-right: 0.8em;
    cursor: pointer;
  }
}

.button {
  width: 160px;
  height: 40px;
  border-radius: 8px;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  cursor: pointer;

  &--primary {
    background-color: #5778fb;
    &:hover {
      background-color: #5656e8;
    }
  }
  &--default {
    background-color: #eaeaf6;
    color: #333;
  }
}

.close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  cursor: pointer;
}
.checkbox__icon {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/versionRevert.vue